import { Dataset } from '../../../types/types';
import { getDataKey } from '../../../utils/getDataKey';
import { getRowId } from '../../../utils/getRowId';

// Select-all keeps the unloaded rows as a count, so the full selection is
// resolved from an unpaginated fetch. Rows the user unchecked are dropped by
// id — matching them by position would break as soon as a sort moved them.
export const fetchMissingRowData = async (
  dataset: Dataset,
  rowsToUse: any[],
  fetchDatasetData: () => Promise<any[]>,
  deselectedRowIds: Set<string>
) => {
  const datasetKey = getDataKey(dataset);

  const data = await fetchDatasetData();

  if (!data) {
    throw new Error('Failed to fetch missing data');
  }

  // Already-loaded rows carry the grid's full column set; the prefetch only
  // asks for id + label, so keep them rather than their fetched twins.
  const keptRowsToUse = rowsToUse.filter((row) => {
    const id = getRowId(row, datasetKey);
    return id === null || !deselectedRowIds.has(id);
  });
  const keptIds = new Set<string>();
  keptRowsToUse.forEach((row) => {
    const id = getRowId(row, datasetKey);
    if (id !== null) keptIds.add(id);
  });

  const extraRows = data.filter((row) => {
    const id = getRowId(row, datasetKey);
    if (id === null) return true;
    return !keptIds.has(id) && !deselectedRowIds.has(id);
  });

  return [...keptRowsToUse, ...extraRows];
};
